document.addEventListener('DOMContentLoaded', function () {
    startApp();
});

function startApp() {
    fixedNav();
    createGallery();
    scrollNav();
}

function fixedNav() {
    const bar = document.querySelector('.header');
    const aboutFest = document.querySelector('.about-festival');
    const body = document.querySelector('body');

    window.addEventListener('scroll', function () {
        // getBoundingClientRect: info del tamaño y la posición de un elemento

        if (aboutFest.getBoundingClientRect().top < 0) {
            bar.classList.add('fixed');
            body.classList.add('body-scroll');

            // añade la clase cuando se pasa el header

        } else {
            bar.classList.remove('fixed');
            body.classList.remove('body-scroll');
            // elimina la clase cuando se vuelve al header
        }
    })
}

function scrollNav() {
    const links = document.querySelectorAll('.main-navigation');
    links.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            // evitar el comportamiento por defecto

            // configurar el nuevo comportamiento
            const scrollValue = e.target.attributes.href.value;
            const scrollSection = document.querySelector(scrollValue);
            scrollSection.scrollIntoView({ behavior: "smooth" });
        });
    });
}

function createGallery() {
    // Crear la galería de miniaturas
    const gallery = document.querySelector('.gallery-image');

    for (let i = 1; i <= 12; i++) {
        const image = document.createElement('PICTURE');
        image.innerHTML = `
        <source srcset="build/img/thumb/${i}.avif" type="image/avif">
        <source srcset="build/img/thumb/${i}.webp" type="image/webp">
        <img loading="lazy" width="200" height="300" src="build/img/thumb/${i}.jpg" alt="image gallery">
        `;

        // Función para ampliar imagen
        image.onclick = function () {
            showImage(i);
            // se construye en modo callback para pasar parámetros
        }

        gallery.appendChild(image);
    }
}

function showImage(id) {
    // Referenciar las imágenes ampliadas
    const image = document.createElement('picture');
    image.innerHTML = `
        <source srcset="build/img/grande/${id}.avif" type="image/avif">
        <source srcset="build/img/grande/${id}.webp" type="image/webp">
        <img loading="lazy" width="200" height="300" src="build/img/grande/${id}.jpg" alt="image gallery">
        `;

    // Mostrar la imagen ampliada
    const overlay = document.createElement('DIV');
    overlay.appendChild(image);
    overlay.classList.add('overlay');

    // Volver a la pantalla principal
    overlay.onclick = function () {
        const body = document.querySelector('body');
        body.classList.remove('body-fix');
        overlay.remove();
    }

    // Botón para cerrar la ventana modal
    const close = document.createElement('P');
    close.textContent = 'X';
    close.classList.add('close-button');

    close.onclick = function () {
        const body = document.querySelector('body');
        body.classList.remove('body-fix');
        overlay.remove();
    }

    overlay.appendChild(close);

    // Añadirlo al HTML
    const body = document.querySelector('body');
    body.appendChild(overlay);
    body.classList.add('body-fix');
}